import { NgModule } from "@angular/core";
import {
  RouterModule,
  Routes,
  provideRouter,
  withComponentInputBinding,
} from "@angular/router";

import { DashboardComponent } from "./dashboard/dashboard.component";
import { FaqComponent } from "./faq/faq.component";
import { UsersComponent } from "./users/pages/users/users.component";
import { MyProfileComponent } from "./my-profile/my-profile.component";
import { UsersModule } from "./users/users.module";

const routes: Routes = [
  {
    path: "",
    component: DashboardComponent,
  },
  {
    path: "ajuda",
    component: FaqComponent,
  },
  {
    path: "my-profile",
    component: MyProfileComponent,
  },
  {
    path: "usuarios",
    title: "Usuários",
    loadChildren: () =>
      import("./users/users-routing.module").then((m) => m.UsersRoutingModule),
  },
  {
    path: "telemarketing",
    title: "Telemarketing",
    loadChildren: () =>
      import("./call-center/call-center-routing.module").then(
        (m) => m.CallCenterRoutingModule,
      ),
  },
  {
    path: "estoque",
    title: "Estoque",
    loadChildren: () =>
      import("./estoque/estoque.module").then((m) => m.EstoqueModule),
  },
  {
    path: "email-marketing",
    title: "E-mail Marketing",
    loadChildren: () =>
      import("./email-marketing/email-marketing.module").then((m) => m.EmailMarketingModule),
  },
  {
    path: "financeiro",
    title: "Financeiro",
    loadChildren: () =>
      import("./financeiro/financeiro.module").then((m) => m.FinanceiroModule),
  },
  {
    path: "blog",
    title: "Blog - Tutoriais",
    loadChildren: () =>
      import("./blog/blog.module").then((m) => m.BlogModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [provideRouter(routes, withComponentInputBinding())],
})
export class PagesRoutingModule {}
